export const VA_DOCUMENT_UPLOAD_SECTIONS = [
  { fieldName: "courtOrder", label: "VA Letter *" },
  { fieldName: "lastWill", label: "Last Will & Testament (Optional)" },
  { fieldName: "otherDocument", label: "Supplemental Needs Trust (Optional)" },
];

export const GUARDIANSHIP_DOCUMENT_UPLOAD_SECTIONS = [
  { fieldName: "courtOrder", label: "Court Order" },
  { fieldName: "lastWill", label: "Last Will" },
  { fieldName: "otherDocument", label: "Other Document" },
];

export const PROBATE_DOCUMENT_UPLOAD_SECTIONS = [
  { fieldName: "courtOrder", label: "Court Order" },
  { fieldName: "lastWill", label: "Last Will and Testament" },
  { fieldName: "otherDocument", label: "Other Document" },
];

export const TRUSTEE_DOCUMENT_UPLOAD_SECTIONS = [
  { fieldName: "courtOrder", label: "Court File" },
  { fieldName: "otherDocument", label: "Supplemental Needs Trust (Optional)" },
];
